"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouteKeys = void 0;
var RouteKeys;
(function (RouteKeys) {
    RouteKeys["SUBSCRIBE"] = "subscribe";
})(RouteKeys = exports.RouteKeys || (exports.RouteKeys = {}));
//# sourceMappingURL=enums.js.map